import api from "@/services/api"

export type LocalFieldUpdateCallback = ((fieldId: string) => void) | null | undefined

/**
 * Notifies the caller that a field was updated by this client so stale hub updates can be ignored.
 */
const markLocalFieldUpdated = (onLocalFieldUpdate: LocalFieldUpdateCallback, fieldId: string) => {
	if (onLocalFieldUpdate && fieldId) {
		onLocalFieldUpdate(fieldId)
	}
}

/**
 * Saves a custom case field and records the client-side update timestamp via callback.
 */
const saveCaseFieldWithTracking = async ({
	caseId,
	fieldId,
	trackedFieldId,
	value,
	inProgressUpdate = false,
	onLocalFieldUpdate
}: {
	caseId: string,
	fieldId: string,
	trackedFieldId?: string,
	value: any,
	inProgressUpdate?: boolean,
	onLocalFieldUpdate?: LocalFieldUpdateCallback
}) => {
	markLocalFieldUpdated(onLocalFieldUpdate, trackedFieldId || `fields.${fieldId}`)
	await api.saveCaseField(caseId, fieldId, value, inProgressUpdate)
}

/**
 * Saves a built-in case property and records the client-side update timestamp via callback.
 */
const saveCasePropertyWithTracking = async ({
	caseId,
	fieldId,
	value,
	onLocalFieldUpdate
}: {
	caseId: string,
	fieldId: string,
	value: any,
	onLocalFieldUpdate?: LocalFieldUpdateCallback
}) => {
	markLocalFieldUpdated(onLocalFieldUpdate, fieldId)
	await api.saveCaseProperty(caseId, fieldId, value)
}

export {
	markLocalFieldUpdated,
	saveCaseFieldWithTracking,
	saveCasePropertyWithTracking
}
